import script from "./menu-bar.vue?vue&type=script&setup=true&lang=js"
export * from "./menu-bar.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__